import { singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { SingleOrArray } from '@dirootie-extensions/typescript';

// /**
//  * Converts array with objects to an object. The
//  * @param {any[]} arr - The array to convert
//  * @param {SingleOrArray<string>}  console.log('KEYS', parentKey- The property name to use as a key when converting the element to object.
//  * @returns {T} Returns the created object
//  */
// export const arrayToObject = <T>(
//   arr: any[],
//   keys?: SingleOrArray<string>
// ): T => {
//   var resultKeys = singleOrArrayToArray(keys);
//   var resultAsObj = arr.reduce((accumulator, el) => {
//     var key =
//       keys !== undefined
//         ? resultKeys.map((x) => el[x]).filter((y) => y !== undefined)[0]
//         : el;
//     return { ...accumulator, [key]: el };
//   }, {});
//   return resultAsObj as T;
// };

export const array2DimensionsToObject = (
  arr: [any, any][],
  sndPositionHandler: (key: any, param: any) => any = (key, ...params) => params
) =>
  arr.reduce((acc, elem) => {
    const [key, ...rest] = elem;
    (acc as any)[key] = sndPositionHandler(key, rest);
    return acc;
  }, {});
